;
export const wsharep = {
    sharetitle: "",
    shareurl: "",
    sharepic: "",
    sharedesc: "与全世界的肿瘤医生一起工作、学习、交流",
    successfun: function () {
        console.log('default wshare succ')
    }
};

if(window.ISAPP) {
    window.JSRegister(
        'shareDoc', // JS Native 约定的通信标识
        (data, callback) => { // data: Native传给JS的数据; callback: Native call JS 的回调
            callback({
                param: {
                    // JS回传给Native的数据
                    title: wsharep.sharetitle,
                    text: wsharep.sharedesc,
                    image: wsharep.sharepic,
                    url: wsharep.shareurl
                }
            });
        }
    );
}

function wxshare(wx) {
    wx.onMenuShareTimeline({
        title: wsharep.sharetitle, // 分享标题
        link: wsharep.shareurl, // 分享链接
        imgUrl: wsharep.sharepic, // 分享图标
        success: function () {
            if(wsharep.successfun) {
                wsharep.successfun();
            }
        },
        cancel: function () {
        }
    });

    wx.onMenuShareAppMessage({
        title: wsharep.sharetitle, // 分享标题
        desc: wsharep.sharedesc, // 分享描述
        link: wsharep.shareurl, // 分享链接
        imgUrl: wsharep.sharepic, // 分享图标
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
            if(wsharep.successfun) {
                wsharep.successfun();
            }
        },
        cancel: function () {
        }
    });

    // JSSDK V1.4 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
    wx.updateAppMessageShareData({
        title: wsharep.sharetitle, // 分享标题（1.4.0）
        desc: wsharep.sharedesc, // 分享描述
        link: wsharep.shareurl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: wsharep.sharepic, // 分享图标
        success: function () {
            if(wsharep.successfun) {
                wsharep.successfun();
            }
        }
    });
    // JSSDK V1.4 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
    wx.updateTimelineShareData({
        title: wsharep.sharetitle, // 分享标题
        link: wsharep.shareurl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: wsharep.sharepic, // 分享图标
        success: function () {
            if(wsharep.successfun) {
                wsharep.successfun();
            }
        }
    });
}

export default function wxwebjsk() {
    if (window.ISWX) {
        var apiurl = process.env.REACT_APP_LC_ZLYS + "/doctor/tp/Index/jsk";
        var url = window.location.href;
        var reqData = {
            url: url
        };

        fetch(apiurl, {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(reqData)
          }).then(data=>{
            data.json().then(res=>{
                console.log('res=>', res);
                window.wx.config({
                    debug: false,
                    appId: res.appId,
                    timestamp: res.timestamp,
                    nonceStr: res.nonceStr,
                    signature: res.signature,
                    jsApiList: [
                        'onMenuShareAppMessage',
                        'onMenuShareTimeline',
                        'updateAppMessageShareData',
                        'updateTimelineShareData',
                        'chooseWXPay',
                        'chooseImage',
                        'closeWindow'
                    ],
                });
                window.wx.ready(function() {
                    wxshare(window.wx);
                });
            });
          });
    }
}
